import { InfoIcon } from "@phosphor-icons/react";
import useIsMobileView from "apps/visits/packages/shared/hooks/useIsMobileView";
import type { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/core/shared/v2/ui/tooltip";

type SummaryBoxProps = {
  icon: ReactNode;
  header: string;
  tooltip?: string;
  children: ReactNode;
};

export const SummaryBox = ({ icon, header, tooltip, children }: SummaryBoxProps) => {
  const isMobile = useIsMobileView();
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 lg:p-6">
      <div className="mb-4 flex items-center gap-x-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-gray-50 text-gray-500 [&>svg]:size-5">
          {icon}
        </span>
        <h3 className="font-heading font-serif text-xl lg:text-2xl">{header}</h3>
        {tooltip && (
          <TooltipProvider delayDuration={200}>
            <Tooltip>
              <TooltipTrigger asChild>
                <button type="button" aria-label={header} className="mt-1 inline-flex cursor-pointer">
                  <InfoIcon className="size-4" />
                </button>
              </TooltipTrigger>
              <TooltipContent side={isMobile ? "bottom" : "right"}>{tooltip}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      {children}
    </div>
  );
};
